import { createAction } from '@reduxjs/toolkit';

import { AppModal } from 'app/types/appModal.types';
import { AppDispatch } from 'bootstrap.store';
import { pubSub } from 'utils/pubSub';

/**
 * Creates a custom show modal action that returns a promise of the user actions
 * within the modal. For example, the user cancelling or confirming.
 *
 * @param type The action type.
 */
// This cannot be explicitly typed as the generic gets passed into the action
// creator function.
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function createShowModalAction(type: string) {
  const action = createAction<Pick<AppModal, 'modal'>>(type);

  return Object.assign(
    <TModal extends AppModal['modal']>(payload: { modal: TModal }) =>
      (dispatch: AppDispatch) => {
        return new Promise<
          Parameters<
            Extract<
              AppModal,
              { modal: { type: TModal['type'] } }
            >['meta']['resolve']
          >[0]
        >((resolve, reject) => {
          dispatch(action(payload));
          pubSub.publish('showModal', {
            type: payload.modal.type,
            meta: { resolve, reject },
          });
        });
      },
    { action },
  );
}
